import './auth.css';
import { MESSAGES } from './messages.js';

/**
 * The two screens a session-guarded route shows around {@link requireSession}: while its
 * `auth.me` check is in flight (`pendingComponent`, with `pendingMs: 0`) and when that check
 * fails for any reason other than a 401 (`errorComponent`). Later packages that guard a route
 * (P0-6, P0-9) reuse both; see `apps/web/src/routes/index.tsx` for the wiring.
 */
export function SessionPending(): React.JSX.Element {
  return (
    <main className="auth-page">
      <div className="auth-card">
        <p role="status">Loading…</p>
      </div>
    </main>
  );
}

export function SessionError(): React.JSX.Element {
  return (
    <main className="auth-page">
      <div className="auth-card">
        <p role="alert">{MESSAGES.networkError}</p>
      </div>
    </main>
  );
}
